module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.7@readable-stream/passthrough.js
// module id = 300
// module chunks = 8